export var BusinessType;
(function (BusinessType) {
    BusinessType["Retail"] = "Retail";
    BusinessType["RetailIntegral"] = "RetailIntegral";
    BusinessType["SelfEmployed"] = "SelfEmployed";
    BusinessType["Enterprise"] = "Enterprise";
    BusinessType["EnterpriseIntegral"] = "EnterpriseIntegral";
})(BusinessType || (BusinessType = {}));
